import React, { memo } from 'react';
import { ModernImageModelNode } from './ModernImageModelNode';
import { GPT_IMAGE_2_CONFIG } from './imageModelConfigs';

export { GPT_IMAGE_2_CONFIG } from './imageModelConfigs';

export const GptImage2Node = memo(props => (
  <ModernImageModelNode {...props} config={GPT_IMAGE_2_CONFIG} />
));
